import { useState } from "react";
import NavList from "./NavList";
import { Link, useLocation } from "react-router-dom";
import SideImg1 from "../../images/sidebar/1.jpg";
import SideImg2 from "../../images/sidebar/2.jpg";
import SideImg3 from "../../images/sidebar/3.jpg";
import SideImg4 from "../../images/sidebar/4.jpg";
import SideImg5 from "../../images/sidebar/5.jpg";
import SideImg6 from "../../images/sidebar/6.jpg";
import Logo from "../../images/logo/logo_transparent.png";
import LogoBlack from "../../images/logo/logo.png";
import WhatsAppIcon from "../../images/logo/whatsapp.png";
import MenuIcon from "../../images/logo/menu_icon.png";
import CloseIcon from "../../images/logo/close_icon.png";

function Navbar() {
  const [spin, setSpin] = useState(false);
  const [sticky, setSticky] = useState(false);
  const [sidebar, setSideBar] = useState(false);
  const [hamburger, setHamburger] = useState(false);
  const location = useLocation();
  const isSchedulePage = location.pathname.startsWith("/schedule");

  const joinSpin = () => {
    setSpin(true);
  };

  const stopSpin = () => {
    setSpin(false);
  };

  // sticky navbar - bg black
  const handleScroll = () => {
    if (window.scrollY > 10) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  // logo
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // sidebar
  const sideBar = () => {
    setSideBar(!sidebar);
  };

  // hamburger menu
  const hamburgerMenu = () => {
    setHamburger(!hamburger);
  };

  return (
    <>
      <nav
        className={`flex flex-row bg-black items-center justify-between py-8 px-12  fixed top-0 left-0 right-0 w-full z-50 ${sticky || isSchedulePage ? "shadow-xl" : ""
          }`}
      >
        <Link to="/">
          <div onClick={goTop} className="flex items-center gap-4 cursor-pointer">
            <img src={Logo} alt="logo" className="w-[120px]" />
            <h2 className="text-white text-[3.5rem] font-bold">
              AK<span className="text-white">FITNESS</span>
            </h2>
          </div>
        </Link>
        <div className="navlist-nav">
          <NavList />
        </div>
        <div className="flex items-center gap-10">
          <div className="flex gap-10">
            {/* mobile menu -------------- */}
            <div
              className={`flex top-0 flex-col fixed w-full h-screen bg-white z-[9999999999] py-[40px] px-[40px] ease-in-out duration-500  ${hamburger ? "right-0" : "-right-full"
                }`}
            >
              {/* top row: logo + close */}
              <div className="flex justify-between items-center mb-16">
                <div className="flex items-center gap-3">
                  <img src={LogoBlack} alt="logo" className="w-[50px]" />
                  <h2 className="text-black text-[2rem] font-bold">
                    AKFITNESS
                  </h2>
                </div>
                <img
                  src={CloseIcon}
                  alt="close"
                  onClick={hamburgerMenu}
                  className="w-[3.5rem] h-[3.5rem] cursor-pointer hover:scale-110 ease-in duration-200"
                />
              </div>

              {/* links */}
              <ul className="text-center flex flex-col gap-10">
                <li onClick={hamburgerMenu}>
                  <a
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    href="/#home"
                  >
                    Home
                  </a>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/about"
                  >
                    About
                  </Link>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/schedule/monday"
                  >
                    Schedule
                  </Link>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/gallery/page-1"
                  >
                    Gallery
                  </Link>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/blog"
                  >
                    Blog
                  </Link>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/contact"
                  >
                    Contact
                  </Link>
                </li>
                <li onClick={hamburgerMenu}>
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    className="text-[2rem] font-medium hover:text-[#ff0336] ease-in duration-200"
                    to="/sessions"
                  >
                    Sessions
                  </Link>
                </li>
              </ul>

              {/* enquire now button */}
              <Link
                to="/contact"
                onClick={() => { hamburgerMenu(); window.scrollTo(0, 0); }}
                className="mt-16 self-center bg-[#ff0336] text-white text-[1.6rem] font-bold uppercase py-5 px-12 tracking-wider hover:bg-black ease-in duration-200"
              >
                Enquire Now
              </Link>
            </div>

            {/* sidebar */}

            <div>
              <div
                className={`flex flex-col fixed w-[40rem] min450:w-full h-[100vh] bg-white top-0 z-[9999999999] p-[45px] gap-24 overflow-x-hidden ease-in-out duration-[0.5s] ${sidebar ? "left-0" : "-left-full"
                  }`}
              >
                {/* logo & X */}
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <img src={LogoBlack} alt="logo" className="w-[50px]" />
                    <h2 className="text-black text-[2.4rem] font-bold">
                      AKFITNESS
                    </h2>
                  </div>
                  <img
                    src={CloseIcon}
                    alt="close"
                    onClick={sideBar}
                    className="w-[3.5rem] h-[3.5rem] cursor-pointer hover:scale-110 ease-in duration-200"
                  />
                </div>
                {/* about us */}
                <div className="flex flex-col gap-6">
                  <h3 className="text-[2rem] font-bold">About Us</h3>
                  <p className="text-[1.6rem] font-medium text-[#000000b1]">
                    Find out who we are and what makes us unique. We are a
                    community-driven gym committed to providing personalized
                    fitness experiences for all levels of fitness enthusiasts in
                    a welcoming and supportive environment.
                  </p>
                </div>
                {/* gallery */}
                <div className="flex flex-col gap-6">
                  <h3 className="text-[2rem] font-bold">Gallery</h3>
                  <div className="grid grid-cols-3 grid-rows-2 gap-4">
                    <img
                      src={SideImg1}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                    <img
                      src={SideImg2}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                    <img
                      src={SideImg3}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                    <img
                      src={SideImg4}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                    <img
                      src={SideImg5}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                    <img
                      src={SideImg6}
                      alt="sidebar_gallery"
                      className="rounded-xl cursor-pointer "
                    />
                  </div>
                </div>
                {/* contact */}
                <div className="flex flex-col gap-6">
                  <h3 className="text-[2rem] font-bold">Contact Info</h3>
                  <p className="text-[1.6rem] font-medium text-[#000000b1] hover:text-[#ff0336] cursor-pointer ease-in duration-200">
                    <i className="fa-solid fa-location-dot text-[#ff0336]"></i>
                    &nbsp; Atulyam Towers, Tilwara Road Near Sagda Chowk, Jabalpur, 482003
                  </p>
                  <p className="text-[1.6rem] font-medium text-[#000000b1] hover:text-[#ff0336] cursor-pointer ease-in duration-200">
                    <i className="fa-solid fa-phone text-[#ff0336]"></i>&nbsp;
                    +91 94067 61177
                  </p>
                  <p className="text-[1.6rem] font-medium text-[#000000b1] hover:text-[#ff0336] cursor-pointer ease-in duration-200">
                    <i className="fa-solid fa-envelope text-[#ff0336]"></i>
                    &nbsp; akfitnessjbp@gmail.com
                  </p>
                </div>
                {/* follow us */}
                <div className="flex flex-col gap-6">
                  <h3 className="text-[2rem] font-bold">Follow Us</h3>
                  <div className="flex gap-5">
                    <a href="https://www.instagram.com/akfitnessjbp/" target="_blank" rel="noreferrer" className="bg-[#ff0336] rounded-full py-[10px] px-[13px] cursor-pointer hover:bg-black ease-in duration-200">
                      <i className="fa-brands fa-instagram text-[2.2rem] text-white"></i>
                    </a>
                    <a href="https://wa.me/919406761177" target="_blank" rel="noreferrer" className="bg-[#128c7e] rounded-full py-[10px] px-[13px] cursor-pointer hover:bg-black ease-in duration-200">
                      <img src={WhatsAppIcon} alt="whatsapp" className="w-[2.2rem] h-[2.2rem] object-contain invert" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* nav icons */}
            <div className="flex items-center gap-8 z-[100]">
              {/* account */}
              <Link onClick={goTop} to="/signup" title="signup_button">
                <i className="fa-regular fa-user text-white text-4xl cursor-pointer hover:text-[#FF0336] ease-in duration-200"></i>
              </Link>
              {/* sidebar */}
              <i
                onClick={sideBar}
                className="fa-regular fa-chart-bar text-white text-4xl cursor-pointer hover:text-[#FF0336] ease-in duration-200"
              ></i>
              {/* hamburger - rightmost */}
              <img
                src={MenuIcon}
                alt="menu_icon"
                onClick={hamburgerMenu}
                className="w-[3rem] h-[3rem] cursor-pointer hover:scale-110 ease-in duration-200 desk:hidden"
              />
            </div>
          </div>
          {/* spin box */}
          <div className="border-[rgb(255,255,255,0.3)] border-solid border-2  p-2 rounded-md min620:hidden">
            <Link
              onClick={goTop}
              to={"/contact"}
              onMouseEnter={joinSpin}
              onMouseLeave={stopSpin}
              className="flex items-center "
            >
              <i
                className={`fa-solid fa-plus bg-[#FF0336] text-white text-2xl py-3 px-4 rounded-md ${spin ? "nav-btn-hover" : ""
                  }`}
              ></i>
              <h3 className="text-white text-[14px] font-bold uppercase ml-4 mr-8 tracking-wider">
                enquire now
              </h3>
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
